const navComponents = [
  {
    page: "About",
    to: "/",
  },
  {
    page: "Career",
    to: "/career",
  },
  {
    page: "Resume",
    to: "/resume",
  },
  {
    page: "Portfolio",
    to: "/portfolio",
  },
  {
    page: "Project",
    to: "/project",
  },
  {
    page: "Contact",
    to: "/contact",
  },
  {
    page: "Blog",
    to: "/blog",
  },
];

export default navComponents;
